import { render, staticRenderFns } from "./SeminarUnitSelection.vue?vue&type=template&id=6fa0061a&scoped=true&lang=pug&"
import script from "./SeminarUnitSelection.vue?vue&type=script&lang=ts&"
export * from "./SeminarUnitSelection.vue?vue&type=script&lang=ts&"
import style0 from "./SeminarUnitSelection.vue?vue&type=style&index=0&id=6fa0061a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0061a",
  null
  
)

export default component.exports